module.exports = __webpack_public_path__ + "img/brokerpay.b17a8543.png";